import Vue from 'vue'
import App from './App.vue'
import router from '@/router';
import ElementUI from 'element-ui';
import '../public/theme/index.css'
import store from '@/store';
import VueMeta from 'vue-meta'
Vue.config.productionTip = false;
Vue.config.devtools = true;
Vue.use(ElementUI);
Vue.use(VueMeta);
import * as echarts from 'echarts'
Vue.prototype.$echarts = echarts // 挂载到Vue原型，组件内可通过this.$echarts访问

router.beforeEach((to, from, next) => {
  // 简化版代码
  const pageTitle = to?.meta?.metaInfo?.title || '客户信息管理系统';
  document.title = pageTitle;
  next();
});

new Vue({
  el: '#app',
  render: h => h(App),
  router,
  store
}).$mount('#app')